export default "__VITE_ASSET__CjOyHkcu__"